<template>
  <div class="title-wrapper">
    <div class="content">
      <marquee :animate="!showCollection">
        {{ collectionInfo?.name }}
      </marquee>
      <div class="title">
        精选集：
      </div>
    </div>
    <div class="num">
      {{ feedNumDesc }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useStore } from '@/store/index';
import Marquee from '@/components/common/marquee.vue';

const { state } = useStore();
const collectionInfo = computed(() => state.collectionInfo);
const showCollection = computed(() => state.showCollection);
const activeIndex = computed(() => state.activeIndex);
const feedNumDesc = computed(() => `${activeIndex.value + 1} / ${collectionInfo.value?.feedNum || 12}`); // 一页一般情况是12条数据

</script>

<style lang="scss" scoped>
.title-wrapper {
  width: 100%;
  text-align: right;
  @include responsiveStyleSingle(font-size, 4.8, 'vw');
  color: #ffffff;
  @include responsiveStyleSingle(padding-left, 4,'vw');
  @include responsiveStyleSingle(padding-right, 4,'vw');
  position: absolute;
  z-index: 15;
  box-sizing: border-box;
  @include responsiveStyleSingle(top, 2.4,'vw');
  left: 0;
  letter-spacing: 0;
  text-shadow: 0 0 6px rgba(0, 0, 0, 0.4);
  .content {
    display: flex;
    font-weight: bold;
    flex-direction: row-reverse;
    .title {
      white-space: nowrap;
    }
  }
}
</style>
